export const getOrgProfileUrl = "/api/v3/org";
export const updateOrgProfileUrl = "/api/v3/org";
export const updateOrgProfileLogoUrl = "/api/v3/org/logo";
